export const GENERAL_ERROR_MESSAGE = 'Something went wrong. Please try again';
